import React, { Component } from "react";

class ContactPage extends Component {
  componentWillMount = () => {
    this.props.setAppDefault();
  };
  componentDidMount = () => {
    window.scrollTo(-100, -100)
  };
  render() {
    return (
      <div
        className="content"
        style={{
          display:
            this.props.appState.currentPage === "contact" ? "block" : "none",
        }}
      >
        <div className="flex-container text-center">
          <p>
            Contact us <br></br>@ <br></br>
            <a href="mailto: spirelab.ee@iisc.ac.in">spirelab.ee@iisc.ac.in</a>
            <br></br>and<br></br>
            Feel free to leave us a feedback{" "}
            <a
              href="https://forms.gle/tTwqpkH1EmNbzqbK9"
              target="_blank"
              rel="noopener noreferrer"
            >
              here
              </a>
              .
          </p>
        </div>

      </div>
    );
  }
}

export default ContactPage;
